module.exports = __webpack_public_path__ + "img/عمومی.dc1ef8c1.png";